<!--
* UIID: UI-DLB-DA-130
* UI Name: Upload File View
* Modify Date: 2020/04/08
-->
<template>
  <v-card class="v-modal-new-window analyzed-dialog analyzed-view-dialog">
    <!-- [S]  Popup title-->
    <v-card-title primary-title class="headline white--text">
      {{ pageTitle }}
    </v-card-title>
    <!-- [E]  Popup title-->

    <!-- [S]  Popup body-->
    <v-card-text class="card-content-file-view">
      <v-row class="r-popup-content">
        <v-col cols="12" sm="6" class="grid-pd">
          <v-row class="v-grid-title row-pd">
            <v-label>Comp File Path</v-label>
          </v-row>
          <v-row class="v-grid-title row-pd">
            <v-input>{{ this.compfile }}</v-input>
          </v-row>
          <v-row>
            <p v-html="comptext"></p>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- [E]  Popup body-->

    <!-- [S]  Popup footer-->
    <v-card-text class="v-card-footer">
      <v-row>
        <v-col cols="12" md="10"></v-col>
        <v-col cols="12" md="2">
          <v-btn class="dialog-btn btn-close float-right" @click="closePopup"
            ><v-icon x-small class="mr-1">fa fa-times</v-icon>{{ $t('btn.common.close') }}</v-btn
          >
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
    </v-card-text>
    <!-- [E]  Popup footer-->
  </v-card>
</template>

<script>
/* globals Store */
import { mapState } from 'vuex';

export default {
  components: {},
  computed: {
    ...mapState('paproc', {
      comptext: 'comptext',
      fileViewWindowParam: 'fileViewWindowParam',
    }),
  },
  data() {
    return {
      pageTitle: 'Comparison File View',
      cmOption: {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        readOnly: true,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'rubyblue',
        extraKeys: {
          F11(cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'));
          },
          Esc(cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
          },
        },
      },
    };
  },
  methods: {
    getFileDataByPath() {
      console.log('open compfile:' + this.compfile);
      Store.dispatch('paproc/readEDIFile', this.compfile);
    },

    removeDialog(dialog) {
      window.opener.fileViewOpenWindow[this.$route.params.id]();
    },

    selectDialog(obj) {
      this.dragStart(obj);
    },

    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },

    close() {
      this.$emit('click-close2');
      this.$refs[this.currentTab].setFieldValidation('name', '');
    },

    downloadEdiFile() {
      var data = new Blob([this.comptext], { type: 'text/plain' });
      var url = window.URL.createObjectURL(data);
      let edifileArr = this.compfile.split('/');
      var a = document.createElement('a');
      a.href = url;
      a.download = edifileArr[edifileArr.length - 1];
      document.body.appendChild(a);
      a.click();
    },

    downloadBizFile() {
      var data = new Blob([this.biztext], { type: 'text/plain' });
      var url = window.URL.createObjectURL(data);
      let bizfileArr = this.bizfile.split('/');
      var a = document.createElement('a');
      a.href = url;
      a.download = bizfileArr[bizfileArr.length - 1];
      document.body.appendChild(a);
      a.click();
    },
  },
  created() {
    if (window.theme) {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }
    let param = this.fileViewWindowParam[this.$route.params.id];
    this.compfile = param['compfile'];
    this.getFileDataByPath();
  },
};
</script>

<style>
.r-popup-content {
  padding: 0px !important;
}
.v-grid-content {
  margin: 5px 0px 0px 0px;
  height: 567px;
  box-sizing: border-box;
  border-radius: 3px;
  padding: 20px 15px 15px 15px;
}
.v-grid-title .v-label {
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  align-items: center;
  color: #12083f;
}
.v-grid-title .v-input {
  height: 30px;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 3px;
}
.v-grid-title .v-input__slot {
  height: 13px;
  font-family: Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 13px;
  display: flex;
  align-items: center;
  letter-spacing: 0.4375px;
  overflow: hidden;
}
.row-pd {
  padding: 0px 10px !important;
}
.CodeMirror {
  width: 100%;
  height: 492px !important;
  margin-top: 0px !important;
}
.btn-grid {
  margin-top: 10px;
}
.v-card {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.v-card-footer {
  padding: 0px 50px 30px 50px;
}
.v-card-footer .row,
.v-card-footer .col-12 {
  padding: 0px !important;
  margin: 0px !important;
}
.card-content-file-view {
  height: 100%;
  padding: 50px 50px 10px 50px !important;
}
.v-grid-title {
  padding: 0px !important;
  margin: 0 0 5px 0;
}
.grid-pd {
  padding: 0px 12.5px;
}

/* Theme Light */
.theme--light .v-grid-title .v-input__slot {
  color: #000000;
}
.theme--light .v-grid-title .v-input {
  background: #ffffff;
  border: 1px solid #cedeff;
}
.theme--light .v-grid-content {
  border: 1px solid #f0f7fb;
  background: #fafcff;
}

/* Theme dark */
.theme--dark .v-grid-content {
  border: none;
  background: #232329;
}
.theme--dark .v-grid-title .v-input {
  background: #2a2c35;
  border: none;
}
.theme--dark .v-grid-title .v-input__slot {
  color: #bbbbbb;
}
.theme--dark .v-grid-title .v-label {
  color: #bbbbbb;
}
.theme--dark .CodeMirror-vscrollbar::-webkit-scrollbar {
  width: 17px;
}
.theme--dark .CodeMirror-vscrollbar::-webkit-scrollbar-track {
  background-color: #595b64;
}
.theme--dark .CodeMirror-vscrollbar::-webkit-scrollbar-thumb {
  background-color: #dedfe0;
}
.theme--dark .CodeMirror-vscrollbar::-webkit-scrollbar-corner {
  background-color: #595b64;
}
.theme--dark .cm-s-rubyblue.CodeMirror {
  color: #bbbbbb;
}
.theme--dark .cm-s-rubyblue span.cm-number,
.cm-s-rubyblue span.cm-attribute {
  color: #0082ba;
}
</style>
